/* GLOBAL POPUP */

const popup = document.querySelectorAll('.popup');
popup.forEach(popup => {
    const close = popup.querySelector('.close');
    close.addEventListener('click', () => {
        popup.classList.remove('open');
    })
})

/* SIZING GUIDE POPUP */

const sizingGuide = document.querySelector('.product .sizing-guide');
sizingGuide.addEventListener('click', () => {
    const popupSizingGuide = document.querySelector('.popup.sizing-guide__popup');
    popupSizingGuide.classList.add('open');
})